import { useEffect, useState } from "react";
import isSsr from "../utils/isSsr";

// To avoid hydration error, the first render always should be false
// https://github.com/vercel/next.js/blob/canary/examples/with-portals/components/ClientOnlyPortal.js
const useShouldItBeMounted = () => {
  const [mount, setMount] = useState(false);

  useEffect(() => {
    if (!isSsr()) {
      setMount(true);
    }
  }, []);

  return mount;
};

export default useShouldItBeMounted;
